<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17 9H7L12 14L17 9Z"
      fill="#495057"
    />
  </svg>
</template>
<script>
export default {
  name: 'DropdownIcon',
}
</script>
